import { useCallback, useEffect, useState } from "react";
import { TfaMethod } from "@/core/constants/tfaMethod";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import { ValidateCode } from "@/shared/ui";
import { AdditionalFlow } from "@/domains/auth/constants/additionalFlow";
import { setResetPasswordMethod } from "@/domains/auth/slice";
import useResetPasswordGoogleCode from "@/domains/auth/hooks/reset-password/useResetPasswordGoogleCode";
import { useAuthFlow } from "@/domains/auth/containers/context";
import AuthTitle from "@/domains/auth/components/AuthTitle";

export default function AuthResetPasswordAuthenticatorContainer() {
  const { openOnly } = useAuthFlow();
  const dispatch = useAppDispatch();
  const [authCode, setAuthCode] = useState("");
  const { checkCodeHandler, checkIsCompleted, checkIsPending, checkError } =
    useResetPasswordGoogleCode();

  const onSubmit = useCallback(async () => {
    checkCodeHandler(authCode);
  }, [checkCodeHandler, authCode]);

  const backHandler = useCallback(() => {
    dispatch(setResetPasswordMethod(null));
  }, [dispatch]);

  useEffect(() => {
    if (checkIsCompleted) {
      openOnly(AdditionalFlow.AuthUpdatePassword);
    }
  }, [checkIsCompleted, openOnly]);

  if (checkIsCompleted) {
    return null;
  }

  return (
    <>
      <AuthTitle back={backHandler}>Сброс пароля</AuthTitle>
      <ValidateCode
        onSubmit={onSubmit}
        description="Перейдите в приложение Auntentificator и скопируйте код"
        type={TfaMethod.AUTHENTICATOR}
        address=""
        onSendCode={() => {}}
        code={authCode}
        onCodeChange={setAuthCode}
        pending={checkIsPending}
        sendCodePending={false}
        error={checkError}
        onResetAccess={() => openOnly(AdditionalFlow.AuthResetTfaAuthenticator)}
      />
    </>
  );
}
